export const stickers = [
  {
    id: "#no_smoking_01",
    src: "/images/stickers/1.png",
    width: 1440,
    height: 578,
  }, // 1.png
  {
    id: "#no_smoking_02",
    src: "/images/stickers/2.png",
    width: 720,
    height: 720,
  }, // 2.png
  {
    id: "#no_smoking_03",
    src: "/images/stickers/3.png",
    width: 720,
    height: 720,
  }, // 3.png
  {
    id: "#no_smoking_04",
    src: "/images/stickers/4.png",
    width: 720,
    height: 720,
  }, // 4.png
  {
    id: "#no_smoking_05",
    src: "/images/stickers/5.png",
    width: 720,
    height: 720,
  }, // 5.png
  {
    id: "#no_smoking_06",
    src: "/images/stickers/6.png",
    width: 720,
    height: 720,
  }, // 6.png
  {
    id: "#no_smoking_07",
    src: "/images/stickers/7.png",
    width: 720,
    height: 720,
  }, // 7.png
  {
    id: "#no_smoking_08",
    src: "/images/stickers/8.png",
    width: 1440,
    height: 576,
  }, // 8.png
  {
    id: "#no_smoking_09",
    src: "/images/stickers/9.png",
    width: 1440,
    height: 576,
  }, // 9.png
  {
    id: "#no_smoking_10",
    src: "/images/stickers/10.png",
    width: 1118,
    height: 1440,
  }, // 10.png
  {
    id: "#no_smoking_11",
    src: "/images/stickers/11.png",
    width: 1120,
    height: 1440,
  }, // 11.png
  {
    id: "#no_smoking_12",
    src: "/images/stickers/12.png",
    width: 1440,
    height: 238,
  }, // 12.png
  {
    id: "#no_smoking_13",
    src: "/images/stickers/13.png",
    width: 1440,
    height: 306,
  }, // 13.png
  {
    id: "#no_smoking_14",
    src: "/images/stickers/14.png",
    width: 1440,
    height: 438,
  }, // 14.png
];

export const characters = [
  {
    id: "#nodam_00",
    src: "/images/characters/0.png",
    width: 685,
    height: 1440,
  }, // 0.png, 685 × 1440 pixels
  {
    id: "#nodam_01",
    src: "/images/characters/1.png",
    width: 905,
    height: 1440,
  }, // 1.png 905 × 1440 pixels
  {
    id: "#nodam_02",
    src: "/images/characters/2.png",
    width: 1031,
    height: 1440,
  }, // 2.png 1031 × 1440 pixels
  {
    id: "#nodam_03",
    src: "/images/characters/3.png",
    width: 719,
    height: 1440,
  }, // 3.png 719 × 1440 pixels
  {
    id: "#nodam_04",
    src: "/images/characters/4.png",
    width: 958,
    height: 1440,
  }, // 4.png 958 × 1440 pixels
  {
    id: "#nodam_05",
    src: "/images/characters/5.png",
    width: 901,
    height: 1440,
  }, // 5.png 901 × 1440 pixels
];
